import { Controller } from "@hotwired/stimulus"

// Handles showing/hiding the value field based on operator selection
// Operators "is_empty" and "is_not_empty" don't require a value
export default class extends Controller {
  static targets = ["operator", "valueContainer"]

  connect() {
    this.updateValueVisibility()
  }

  operatorChanged() {
    this.updateValueVisibility()
  }

  updateValueVisibility() {
    const operator = this.operatorTarget.value
    const hideValue = operator === "is_empty" || operator === "is_not_empty"

    if (hideValue) {
      this.valueContainerTarget.classList.add("hidden")
      // Clear the value when hidden to avoid stale data
      const input = this.valueContainerTarget.querySelector("input")
      if (input) {
        input.value = ""
      }
    } else {
      this.valueContainerTarget.classList.remove("hidden")
    }
  }
}
